<template>
    <div>
        <h3 class="title is-3">Employee TimeSheet</h3>
        <hr />
        <GuestEmployeeTimeSheet/>
    </div>
</template>

<script>
import GuestEmployeeTimeSheet from '@/components/TimeSheet/Guest/GuestEmployeeTimeSheet.vue'

export default {
    components: {
        GuestEmployeeTimeSheet
    }
};
</script>
